require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Kinvey/js-sdk/node_modules/core-js/fn/array/find-index.js
// module id = 503
// module chunks = 0